export default {
  primaryColor: '#ED3B41',
  primaryLight: '#FA0050',
  lightRed: '#f75d60',
  secondaryColor: '#333',
  whiteColor: '#ffffff',
  tertiaryColor: '#76b5f1',
  blackColor: '#000000',
  grayColor: '#7f7f7f',
  alertGreen: '7bb32e',
  mediumGrey: '#929292',
  fontSm: '10px;',
  fontMd: '12px',
  // New Website Colors
  lightWhite: '#f7f7f7',
  tintGray: '#F5F7FA',
  btnGreen: '#36B553',
  iconYellow: '#FF9E2C',
  webGray: '#EAECF4',
  lightGray: '#ccc',
  LandingBlack: '#171717',
  borderGray: '#7070704D',
  matrixPurple: '#43506A5D',
  btnGray: '#F8F9FB',
  hotRed: '#DB161E',
  lightBorder: '#DEDEDF',
  transparentColor: 'transparent',
  lightGreen: '#55CA8C',
  ghostWhite: '#f1f2f8',
  mystic: '#d6e5e9',
  pillOrange: '#e65e2d',
  corellBlue: '#2180c4',
  gradientWebGrayColor: 'transparent linear-gradient(282deg, #FFFFFF 0%, #EAECF4 100%) 0% 0% no-repeat padding-box',
  breakpoints: ['576px', '768px', '992px', '1200px', '1530px'],
  vividBlue: '#2684FF',

  // Fonts
  OpenSans: 'Open Sans, sans-serif',
  Muli: 'Muli, sans-serif',
  pinkLemonade: '#FFEAEA',
  whiteTransparentBase: '#ffffffe8',
  gray89: '#e3e3e3',
  grylicBlack: '#252422',
  saviourGradient: 'transparent linear-gradient(180deg, #EAECF4 0%, #FFFFFF 100%)',
  blenderCreamy: '#FFFBED',
  hypeGray: '#F5F6FA',
  nancyBorder: '#E4E4E4',
  infoColor: '#FFA500',
  CardGray: '#F5F5F5',
  CardLightGray: '#17171780',
  blenderGray: '#F5F5F5',
  touchFeatherGray: '#F9F9FC',

  smokeWhiteGrey: '#f3f4f7',
  ironSideGrey: '#676767',
  greyGoose: '#d2d2d2',
};



// WEBPACK FOOTER //
// client/theme.js